import LabelT from '@components/tailwind-components/Label/LabelT';
import type { LLMUsageCheckResultStatus } from '@conversed/rest/src/contracts/llm-usages/check-results';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { iconsHelper } from '../utils/iconsHelper';

export interface Props {
  statuses: Record<
    LLMUsageCheckResultStatus,
    {
      icon: string;
      fontColorHex: string;
    }
  >;
  status: LLMUsageCheckResultStatus | '';
  setStatus: (status: LLMUsageCheckResultStatus) => void;
}

export const FactCheckingStatusSection: React.FC<Props> = ({
  statuses,
  status,
  setStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div className='fact-checking-status'>
      <h3 className='fact-checking-status__title'>This answer is:</h3>
      <div className='fact-checking-status__options'>
        {Object.entries(statuses).map(([key, { icon, fontColorHex }]) => (
          <div
            key={key}
            className='fact-checking-status__option'
            onClick={() => setStatus(key as LLMUsageCheckResultStatus)}>
            <i
              className={`fact-checking-status__icon ${
                key === status
                  ? 'fact-checking-status__icon--active'
                  : 'fact-checking-status__icon--inactive'
              }`}>
              <img
                src={iconsHelper[icon]}
                alt={status}
                className='inline-flex w-6 h-6 items-center mb-1'
              />
            </i>
            <LabelT
              text={t(`train-ai.fact-checking.status.${key}`)}
              className='fact-checking-status__label'
              style={{
                color: status === key ? `${fontColorHex}` : '#c1c1c1',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FactCheckingStatusSection;
